<script setup lang="ts">
import ContentLayout from "@/components/ContentLayout/ContentLayout.vue";
import ErrorPage from "@/components/ErrorPage/ErrorPage.vue";
import { LuvHeadline, LuvText } from "@polargold/luv-ui-library";
import { useI18n } from "vue-i18n";
import GoToStartPage
    from "@/components/Checkout/GoBackButton/GoToStartPage.vue";

const { t } = useI18n();
</script>

<template>
    <ContentLayout>
        <template #subHeader>
            <GoToStartPage/>
        </template>

        <ErrorPage>
            <template #headline>
                <LuvHeadline headlineStyle="h3">
                    {{ t("VIEWS.CHECKOUT.ERROR_PAGE.HEADLINE") }}
                </LuvHeadline>
            </template>

            <template #subHeadline>
                <LuvText>
                    {{
                        t("VIEWS.CHECKOUT.ERROR_PAGE.SUB_HEADLINE")
                    }}
                </LuvText>
            </template>

        </ErrorPage>
    </ContentLayout>
</template>